import {
	DetailedHTMLProps,
	InputHTMLAttributes,
	forwardRef,
	ReactNode,
} from 'react';
import { IUIComponentProps } from '../../types';
import { VisuallyHiddenInput } from '../Input';
import { StyledCheckbox, StyledCheckboxIcon } from './StyledCheckbox';
import Check from '../../assets/check.svg';

export interface ICheckboxProps
	extends IUIComponentProps,
		Omit<
			DetailedHTMLProps<
				InputHTMLAttributes<HTMLInputElement>,
				HTMLInputElement
			>,
			'ref'
		> {
	invalid?: boolean;
	label: ReactNode;
	ariaLabel?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, ICheckboxProps>(
	(
		{ className, ariaLabel, label, disabled, invalid, ...rest }: ICheckboxProps,
		ref,
	) => (
		<StyledCheckbox disabled={disabled} className={className}>
			<VisuallyHiddenInput
				ref={ref}
				type="checkbox"
				disabled={disabled}
				aria-invalid={invalid}
				aria-label={typeof label === 'string' ? ariaLabel ?? label : ariaLabel}
				{...rest}
			/>
			<StyledCheckboxIcon invalid={invalid}>
				<Check />
			</StyledCheckboxIcon>
			{typeof label === 'string' ? <div>{label}</div> : label}
		</StyledCheckbox>
	),
);
